module.exports = require('lodash/template');
